import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73f61a20&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f61a20')) {
      api.createRecord('73f61a20', component.options)
    } else {
      api.reload('73f61a20', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73f61a20&", function () {
      api.rerender('73f61a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-fullscreen/index.vue"
export default component.exports